module.exports = __webpack_public_path__ + "static/media/EHS-Financial-Irregularities.bf1a869c.pdf";